"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 20.7",
    width: "24.5",
    height: "20.7"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,20.7H0.5c-0.2,0-0.3-0.1-0.4-0.3C0,20.3,0,20.1,0.1,20l2.3-3.9l0.9,0.5l-1.9,3.2h21.7l-1.8-2.8l0.8-0.5l2.2,3.6 c0.1,0.2,0.1,0.3,0,0.5C24.4,20.6,24.2,20.7,24,20.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.7,7.4l-3.4-6l-1.8,3.2L9.6,4.2l2.3-3.9c0.2-0.3,0.7-0.3,0.9,0l3.9,6.7L15.7,7.4z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#9ECE06",
    points: "3.7,5.4 3.7,18.7 5.7,18.7 5.7,13 11.8,13 11.8,11 5.7,11 5.7,7.4 11.8,7.4 11.8,5.3       "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M18.9,8.4h-8.3v3.2V13l0,0c0,0.5,0,1.1,0,1.6l0,0v0.9v3.3H17h1.9c0.3,0,1.7-0.6,1.9-1.5 c0.1-0.2,0.1-0.6,0.1-0.6v-2.1c-0.1-0.2-0.6-0.6-0.7-0.7c-0.1,0-0.1-0.1-0.1-0.1c0.4-0.1,0.7-0.5,0.9-0.8V9.5 C20.6,9.1,20,8.5,18.9,8.4z M19,16.3c-0.2,0.3-0.6,0.4-0.7,0.4h-1.7h-4v-0.8v-0.5v-0.9h5.7c0.4,0,0.7,0.2,0.8,0.4 c0.2,0.3,0.2,0.4,0.2,0.7C19.3,16,19.1,16.2,19,16.3z M19.2,12c-0.2,0.3-0.4,0.5-0.9,0.6h-1.7h-4.1v-1V11v-0.6h5.7 c0.4,0,0.7,0.3,0.8,0.5c0.1,0.1,0.2,0.3,0.2,0.6C19.3,11.7,19.2,11.8,19.2,12z"
  }));
};

exports["default"] = _default;